import {decorate, observable, action} from "mobx"

export class BackdropStore {
  isOpen = false
  setIsOpen(bool) {
    this.isOpen = bool
  }
}

decorate(BackdropStore, {
  isOpen: observable,
  setIsOpen: action,
})
